import { all, fork } from "redux-saga/effects"

import LayoutSaga from "./layout/saga"
import OrderDocSaga from "./orderDoc/saga"
import MessageSaga from "./message/saga"

export default function* rootSaga() {
  yield all([
    fork(LayoutSaga),
    fork(OrderDocSaga),
    fork(MessageSaga),
  ])
}
